import React from 'react';

// 영웅 이미지 로더 + 스킬 배치 위치 라벨 (sena 페이지 공용)
// require 경로는 이 파일 위치 기준이므로 src/pages/sena 안에 있어야 한다.
// (webpack이 빌드 시 ally/enemy 폴더를 context module로 통째로 포함 → 영웅 추가 시 코드 수정 불필요)

const side = (heroType) => (heroType === 'ENEMY' ? 'enemy' : 'ally');

// 관리자 화면에서 등록된 영웅 — 이미지가 번들에 없고 서버에 있다.
// 서버가 알려준 목록만 URL 로 폴백한다(없는 영웅까지 URL 로 만들면 깨진 이미지가 뜬다).
const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';
let uploadedHeroes = new Set();

export const setUploadedHeroes = (names) => { uploadedHeroes = new Set(names || []); };

// 방금 등록한 영웅은 목록을 다시 받지 않아도 바로 이미지가 보이게 한다
export const addUploadedHero = (name) => { if (name) uploadedHeroes.add(name); };

const uploadedUrl = (heroNm, file) =>
  uploadedHeroes.has(heroNm) ? `${API_BASE}/sena/hero/img/${encodeURIComponent(heroNm)}/${file}` : null;

// 초상화 — 번들 → 서버 업로드분 → null (호출부에서 텍스트 폴백)
export const heroPortrait = (heroNm, heroType) => {
  try { return require(`../../assets/sena/heroes/${side(heroType)}/${heroNm}/portrait.png`); }
  catch { return uploadedUrl(heroNm, 'portrait.png'); }
};

// 스킬 이미지 — skillNo 1(스킬1) / 2(스킬2) / 3(각성 스킬)
export const skillImg = (heroNm, heroType, skillNo) => {
  try { return require(`../../assets/sena/heroes/${side(heroType)}/${heroNm}/skill${skillNo}.png`); }
  catch { return uploadedUrl(heroNm, `skill${skillNo}.png`); }
};

// 스킬 배치 위치 라벨 — skillNo = 게임 내 스킬 카드 위치
// 1: 아래, 2: 위, 3: 각성 스킬(항상 최상단)
export const SKILL_POS = {
  1: { text: '▼ 아래 ▼', className: 'gd-skill-pos-down' },
  2: { text: '▲ 위 ▲', className: 'gd-skill-pos-up' },
  3: { text: '★ 최상단 ★', className: 'gd-skill-pos-top' },
};

export const skillPos = (skillNo) => SKILL_POS[skillNo] || SKILL_POS[1];

// 스킬 이름 — 게임 내 카드 위치 기준 호칭 (1=아랫스킬, 2=윗스킬, 3=각성)
export const SKILL_LABEL = { 1: '아랫스킬', 2: '윗스킬', 3: '각성' };

export const skillLabel = (skillNo) => SKILL_LABEL[skillNo] || `스킬${skillNo}`;

// 조회 화면 스킬 카드의 위치 배지 (공성/레이드/돌발/강림원정대 공용)
export const SkillPosLabel = ({ skillNo }) => {
  const pos = skillPos(skillNo);
  return <span className={pos.className}>{pos.text}</span>;
};
